import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';
import { getApiErrorMessage } from '../utils/apiResponse';

const TOAST_BASE = {
  position: 'top',
  duration: 5000,
  isClosable: true,
  containerStyle: {
    zIndex: 10000,
  },
};

const STATUS_TITLES = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
};

export function useAppToast() {
  const toast = useToast();

  const showToast = useCallback(
    (status, message, title) => {
      if (!message) return;
      toast({
        ...TOAST_BASE,
        status,
        title: title || STATUS_TITLES[status] || 'Notice',
        description: message,
      });
    },
    [toast]
  );

  const showSuccess = useCallback(
    (message, title) => showToast('success', message, title),
    [showToast]
  );

  const showError = useCallback(
    (message, title) => showToast('error', message, title),
    [showToast]
  );

  const showWarning = useCallback(
    (message, title) => showToast('warning', message, title),
    [showToast]
  );

  const showApiError = useCallback(
    (error, fallback = 'Request failed') => {
      showError(getApiErrorMessage(error, fallback));
    },
    [showError]
  );

  return { showSuccess, showError, showWarning, showApiError, toast };
}
